export enum MeasurementCategoryType {
  three_way_split,
  five_way_split,
  non_classifiable
}



// WEBPACK FOOTER //
// ./src/app/models/enums/measurementcategorytype.ts